module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Rain#1-920ae1385c0f1f7a3f094f361be1e319.svg";